/*** QUESTION ***/

import { CLASSPREFIX } from "../config/constants"
import { QuestionOptions } from "../config/interfaces";

// Libraries
var _ = require('lodash');

export default class Question {
    id: string;
    targetQuestion: HTMLElement;
    questionOptions: QuestionOptions = { title: "", type: "text", answers: [] };
    optionSelected: string = "";

    constructor(id: string, questionOptions: QuestionOptions) {
        this.id = id;
        this.questionOptions = { ...this.questionOptions, ...questionOptions };
    }

    // CREA EL HTML DE LA PREGUNTA
    createQuestionContainer(questionIndex: number) {
        let { title, answers, type } = this.questionOptions
        let questionMarkup: string;

        let optionClasses = [`${CLASSPREFIX}-trivia__question`]
        if (questionIndex == 0) optionClasses.push(`${CLASSPREFIX}-trivia__question--active`)
        if (type == 'image') optionClasses.push(`${CLASSPREFIX}-trivia__question--image`)

        questionMarkup =
            `<div id="question_${this.id}" class="${optionClasses.join(' ')}">
                <h2 class="${CLASSPREFIX}-trivia__question-title">${title}</h2>
                <div class="${CLASSPREFIX}-trivia__question-list">
                ${_.shuffle(answers).map((option: any) => (
                `<div class="${CLASSPREFIX}-trivia__question-option">
                    <input type="radio" name="question_${this.id}" id="option_${option.id}" value="${option.id}"/>
                    ${type == 'image' ? 
                    `<label for="option_${option.id}"><img src="${option.value}"/></label>` :
                    `<label for="option_${option.id}">${option.value}</label>`}
                </div>`
                )).join('')}
                </div>
            </div>`
        return questionMarkup
    }

    // ASIGNA EVENTOS A LOS ELEMENTOS
    setHandlerEvents() {
        let { onSelectedOption } = this.questionOptions

        // GUARDA LA OPCION ESCOGIDA
        this.targetQuestion = document.querySelector(`#question_${this.id}`);
        if (this.targetQuestion) this.targetQuestion.addEventListener('click', ({ target }: any) => {
            if (target.hasAttribute('type')) {
                this.optionSelected = target.value;
                if (onSelectedOption) onSelectedOption()
            }
        })
    }
}